@import '~style-sheet-helpers/core.less';
@import '../../../../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../../../../constants/spacing.module.less';
@import '../../../../../../../constants/screen-width-breakpoints.module.less';
.ship-from-manager {
  width: 100%;
  max-width: 870px;
  padding: @space-0 @space-16;
  overflow: visible;
  align-items: center;
  justify-content: center;
  margin: @space-0 auto;
  text-align: left;
}

.header {
  font-weight: 700;
}

.ship-from-cards-wrapper {
  width: 100%;
  padding: @space-0;
  align-items: center;
}

.ship-from-cards-header {
  gap: @space-8;
  width: 100%;
  max-width: 100%;
  text-align: left;
}

.separator {
  height: 1px;
  background-color: var(--gray-E4E5E7);
  margin: @space-16 @space-0 @space-24;
  width: 100%;
}
